import { motion } from 'framer-motion';
import CountUp from 'react-countup';

export default function ProjectBuild() {
  const services = [
    {
      icon: '/globe.png',
      title: 'Completed Projects',
      count: 200,
    },
    {
      icon: '/clientprotection.png',
      title: 'Clients Protection',
      count: 100,
    },
    {
      icon: '/securityservice.png',
      title: 'Service Guarantee',
      count: 100,
    },
    {
      icon: '/teamexpert.png',
      title: 'Team Experts',
      count: 70,
    },
  ];

  return (
    <div className="mt-[0rem] flex w-full justify-center py-[4rem] font-inter md:mt-[6rem]">
      <div className="mx-[2rem] flex w-full max-w-[114rem] flex-col items-stretch justify-center gap-[0rem] rounded-[1rem] bg-[#011936] px-[2rem] py-[2rem]">
        {/* ===== SMALL SERVICES GRID ===== */}
        <div className="flex w-full flex-wrap items-center justify-between py-[1rem]">
          {services.map((item, index) => (
            <motion.div
              key={index}
              className="flex w-[49.5%] flex-col items-center justify-center gap-[0.5rem] rounded-md py-[1.5rem] md:w-[24.5%]"
              initial={{ opacity: 0, y: -50 }} // start above
              whileInView={{ opacity: 1, y: 0 }} // animate into place
              viewport={{ once: true, amount: 0.5 }} // trigger when 50% visible
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              <img src={item.icon} alt={item.title} className="aspect-1 w-[4.8rem]" />
              <p className="text-[3.2rem] font-[600] leading-[4.8rem] text-white">
                <CountUp end={item.count} duration={2} />
                <span className="text-[#0ec9ac]">+</span>
              </p>
              <p className="w-full text-center text-[1.6rem] leading-[2.6rem] text-[#999]">
                {item.title}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
